import * as globals from '@wandb/weave/common/css/globals.styles';
import React from 'react';
// eslint-disable-next-line wandb/no-deprecated-imports
import styled from 'styled-components';

export const AnonymousNudgeBarText = styled.div`
  display: flex;
  flex-direction: column;
  width: auto;
  align-self: center;
`;

export const AnonymousNudgeBarButton = styled.div`
  display: flex;
  flex-direction: column;
  align-self: center;
  height: 40px;
`;

export const AnonymousNudgeBarTitle = styled.span`
  font-size: 16px;
  padding-right: 16px;
  // padding-top: 10px;
  text-align: left;
`;

export const AnonymousNudgeBarAction = styled.h1`
  font-size: 16px;
`;

export const AnonymousNudgeBarActionLink = styled.a`
  height: 40px;
  font-size: 16px;
  color: ${globals.white};
  border: 1px solid white;
  border-radius: 4px;
  background-color: transparent;
  padding-top: 7px;
  padding-left: 18px;
  padding-right: 18px;
  // width: 125px;
  align-self: center;

  &:hover {
    color: ${globals.white};
  }
`;

export const AnonymousNudgeBar: React.FC = styled.div<{bgColor?: 'errorDark'}>`
  background-color: ${p => globals[p.bgColor ?? 'errorDark']};
  color: ${globals.white};
  text-align: center;
  padding: 32px;
  display: flex;
  height: 80px;

  border-bottom: 1px solid ${globals.white};
`;
